module.exports = __webpack_public_path__ + "img/KP.ed50336b.svg";